import React from "react";
import { ServiceTypeEnum } from "../types";
import { Checkbox, CheckboxGroup } from "@origin-digital/ods-core";
import { Field, FieldInputProps, useFormikContext } from "formik";
import { BulkDuplicateFormValues } from "./types";

const BulkDuplicateAssociatedServices: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<BulkDuplicateFormValues>();

  const handleServicesChange = (serviceType: string, isChecked: boolean) => {
    if (isChecked) {
      //Add to array
      setFieldValue("selectedServices", [
        ...values.selectedServices,
        serviceType,
      ]);
    } else {
      //Remove from array
      setFieldValue(
        "selectedServices",
        values.selectedServices.filter((s) => s !== serviceType)
      );
    }
  };

  const isServiceAvailable = (serviceType: string) => {
    return values.services.some(
      (service) => service.service_type === serviceType
    );
  };

  return (
    <CheckboxGroup
      id="services-checkbox-group"
      label="What request details would you like copied to the new premises?"
      helperText="This field is optional and if no service are selected, the service details will be left blank in the new draft."
    >
      <Field type="checkbox" name="selectedServices" value="ELECTRICITY">
        {({ field }: { field: FieldInputProps<string[]> }) => (
          <Checkbox
            {...field}
            id="electricity-checkbox"
            value="ELECTRICITY"
            label="Electricity"
            checked={values.selectedServices.includes(
              ServiceTypeEnum.ELECTRICITY
            )}
            disabled={!isServiceAvailable(ServiceTypeEnum.ELECTRICITY)}
            onChange={(e) =>
              handleServicesChange(
                ServiceTypeEnum.ELECTRICITY,
                e.target.checked
              )
            }
            helperText={
              isServiceAvailable(ServiceTypeEnum.ELECTRICITY)
                ? ""
                : "Not added to the original request, but you can add it later."
            }
          />
        )}
      </Field>
      <Field type="checkbox" name="selectedServices" value="GAS">
        {({ field }: { field: FieldInputProps<string[]> }) => (
          <Checkbox
            {...field}
            id="gas-checkbox"
            value="GAS"
            label="Natural gas"
            checked={values.selectedServices.includes(ServiceTypeEnum.GAS)}
            disabled={!isServiceAvailable(ServiceTypeEnum.GAS)}
            onChange={(e) =>
              handleServicesChange(ServiceTypeEnum.GAS, e.target.checked)
            }
            helperText={
              isServiceAvailable(ServiceTypeEnum.GAS)
                ? ""
                : "Not added to the original request, but you can add it later."
            }
          />
        )}
      </Field>
      <Field type="checkbox" name="selectedServices" value="BROADBAND">
        {({ field }: { field: FieldInputProps<string[]> }) => (
          <Checkbox
            {...field}
            id="broadband-checkbox"
            value="BROADBAND"
            label="Internet"
            checked={values.selectedServices.includes("BROADBAND")}
            disabled={!isServiceAvailable("BROADBAND")}
            onChange={(e) =>
              handleServicesChange("BROADBAND", e.target.checked)
            }
            helperText={
              isServiceAvailable("BROADBAND")
                ? ""
                : "Not added to the original request, but you can add it later."
            }
          />
        )}
      </Field>
    </CheckboxGroup>
  );
};
export default BulkDuplicateAssociatedServices;
